<template>
    <div class="auth-style">
      <div class="container">
        <div class="image">img</div>
        <h2>PC-Mazal</h2>
        <p>aaa</p>
      </div>
  
      <div class="buttons">
        <button class="auth-button" @click="goToLogin">Se connecter</button>
      </div>
    </div>
  </template>
  
  <script setup>
  import { useRouter } from 'vue-router';
  
  const router = useRouter();
  
  const goToLogin = () => {
    router.push('/auth/sign-in');
  };
  </script>
  
  <style scoped>
  .image {
    background-color: black;
    width: 15vh;
    aspect-ratio: 1 / 1;
  }
  
  .auth-style {
    display: flex;
    flex-direction: column;
    height: 100vh;
    justify-content: space-between;
  }
  
  .container {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  
  .buttons {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2vh;
    margin-bottom: 5vh;
  }
  
  .auth-button {
    width: 70vw;
    height: 6vh;
    font-size: 2vh;
    border: none;
    border-radius: 8px;
    background-color: #007bff;
    color: white;
  }
  </style>